//  Module Vuex de l'application
import axios from 'axios'

const state = {
    manoeuvres_membre: []
}

const actions = {
    getManoeuvresMembre(context, payload) {
        // création d'une Promise
        return new Promise ((resolve, reject) => {
            axios.get('api/user/manoeuvres_membre/' + payload)
                .then((response) => {
                    
                    context.commit('majManoeuvresMembre', response.data.manoeuvres)
                    // si tout s"est bien passé, on renvoie au demandeur le résultat
                    resolve(response);
                })
                .catch((error) => {
                    
                    // si erreur on renvoie au demandeur l'erreur
                    reject(error);
                })

        })
    }
}

const mutations = {
    majManoeuvresMembre(state, payload) {
        state.manoeuvres_membre = payload
    }
}

const getters = {
    manoeuvresMembre(state) {
        return state.manoeuvres_membre
    }
}

export default{
    state,
    actions,
    mutations,
    getters
}